import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./Redux/Store";
import MainApp from "./MainApp";

function App() {
  return (
    <Provider store={store}>
      <Router>
        
        <MainApp />
      </Router>
    </Provider>
  );
}

export default App;
